"use client";

import { motion } from "framer-motion";
import { ThemeSetter } from "../../components/theme/ThemeProvider";

export default function ManifestoPage() {
  return (
    <>
      <ThemeSetter theme="light" />
      <main className="hero">
        <motion.div
          className="mx-auto flex max-w-4xl flex-col items-center text-center"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h1 className="mb-8 font-grotesk text-4xl md:text-6xl text-primary">
            The PhytonCoin Manifesto
          </h1>
          <div className="grid gap-10 text-left text-lg leading-relaxed md:grid-cols-2 md:gap-12 md:text-xl" style={{ color: "var(--text)" }}>
            <div className="space-y-6">
              <h2 className="text-sm uppercase tracking-[0.4em] text-primary">Why We Exist</h2>
              <p>
                Every major blockchain has answered the same question the same way: who gets to produce value?
                Bitcoin says miners. Ethereum says stakers. PhytonCoin says everyone.
              </p>
              <p>
                The proof isn&rsquo;t your hardware or your capital. It&rsquo;s what you do.
                That&rsquo;s not a positioning statement — it&rsquo;s the protocol.
              </p>
            </div>
            <div className="space-y-6">
              <h2 className="text-sm uppercase tracking-[0.4em] text-primary">What We Stand For</h2>
              <p>
                Open access without compromise. Anyone with a device can participate —
                no mining rigs, no minimum stake, no permission required.
              </p>
              <p>
                Privacy by design. Contributions are verified without exposing what
                the contributor was doing. The network learns enough to reward fairly,
                and nothing more.
              </p>
            </div>
          </div>
          <motion.span
            className="mt-12 inline-flex items-center gap-2 text-primary text-base"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.8, duration: 0.8 }}
          >
            PhytonCoin — Proof of Action
          </motion.span>
        </motion.div>
      </main>
    </>
  );
}
